// auth.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { API_ENDPOINTS, KEYS } from '../../constants';
import { Permission, User } from '../../models';
import { PiopiyService } from '../voiceService/piopiy.service';


const BASE_URL = environment.apiBaseUrl;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUserSubject = new BehaviorSubject<User | null>(null);
  private tokenDecode: any = {};
  constructor(
    private http: HttpClient,
    private router: Router,
    // private piopyService: PiopiyService


  ) {
    const userData = localStorage.getItem('user');
    if (userData) this.currentUserSubject.next(JSON.parse(userData));
    
  }

  initAuth() {
  const auth = localStorage.getItem(KEYS.TOKEN);

  if (auth) {
    this.currentUserSubject.next(jwtDecode(auth));
    return true;
  }

  return false;
}

  signup(signupData: any): Observable<any> {
    let { email, password, firstName, lastName, phoneNo } = signupData;

    const url = `${BASE_URL}${API_ENDPOINTS.USERS}`;
    return this.http.post<any>(url, {
      email,
      password,
      firstName,
      lastName,
      phoneNumber: phoneNo,
      role: 'AGENT',
      permissionFlags: 1,
    });
  }

  login(loginData: any): Observable<any> {
    let { email, password } = loginData;

    const url = `${BASE_URL}${API_ENDPOINTS.AUTH}`;
    return this.http.post<User>(url, {
      email,
      password,
    }).pipe(
      tap((res) => {
        console.log('AuthService', res);
        if (res.accessToken) {
          localStorage.setItem(KEYS.TOKEN, res.accessToken);
          localStorage.setItem(KEYS.USER, JSON.stringify(jwtDecode(res.accessToken)));
          this.currentUserSubject.next(jwtDecode(res.accessToken));
          const userCreds = localStorage.getItem(KEYS.USER);
          if(userCreds) {
            const user = JSON.parse(userCreds);
            delete user.telecmi
            localStorage.setItem(KEYS.USER,JSON.stringify(user))
          }
        }
      })
    );
  }
  public logout(): void {
    this.clear();
    this.router.navigate(['/login']);
  }
  public clear() {
    // Clear the token and navigate to the login page
    localStorage.clear();
    sessionStorage.clear();
    this.currentUserSubject.next(null);
  }
  getToken(): string | null {
    return localStorage.getItem(KEYS.TOKEN);
  }

  getCurrentUser(): User | null {
    return this.currentUserSubject.value;
  }

  hasRole(role: string): boolean {
    return this.currentUserSubject.value?.role === role;
  }

  hasPermission(permissionName: string): boolean {
    return this.currentUserSubject.value?.permissions?.some(
      (p) => p.name === permissionName
    ) ?? false;
  }

  hasAnyPermission(permissionsToCheck: string[]): boolean {
    return this.currentUserSubject.value?.permissions?.some(
      (p) => permissionsToCheck.includes(p.name)
    ) ?? false;
  }

  private hasToken(): boolean {
    return this.isTokenValid();
  }

  public isTokenValid(): boolean {
    const token = localStorage.getItem(KEYS.TOKEN);
    if (token) {
      const decodedToken: any = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      return decodedToken.exp > currentTime;
    }
    return false;
  }

  public checkToken(): void {
    // Check token validity and logout if expired
    if (!this.isTokenValid()) {
      this.logout();
    }
  }

  requestOtp(body: any): Observable<any>{
    return this.http.post(`${BASE_URL}${API_ENDPOINTS.REQUEST_OTP}`, body)
  }

  verifyOtp(body: any): Observable<any>{
    return this.http.post(`${BASE_URL}${API_ENDPOINTS.VERIFY_OTP}`, body)
  }
}


